import { DataNode } from "@/atoms"

export const getRootItems = (
  items: { node: DataNode; pos: string }[]
): { node: DataNode; pos: string }[] => {
  const posSet = new Set(items.map((i) => i.pos))

  const hasAncestorInSet = (pos: string): boolean => {
    const parts = pos.split("-")

    for (let i = parts.length - 1; i > 0; i--)
      if (posSet.has(parts.slice(0, i).join("-"))) return true

    return false
  }

  return items.filter((item) => !hasAncestorInSet(item.pos))
}

export const isRootSelected = (
  pathSelected: string[] | undefined,
  tree: DataNode[]
): boolean =>
  !!pathSelected?.some((key) => tree.some((item) => item.key === key))
